<template>
  <v-list two-line class="pa-0">
    <v-list-item-group>
      <div v-for="(item, index) in items" :key="index">
        <training-material-list-item class="course-additional" :item="item" />
        <v-divider v-if="index + 1 < item.length" :key="index"></v-divider>
      </div>
    </v-list-item-group>
  </v-list>
</template>
<script>
import TrainingMaterialListItem from "@/pages/authenticated/courses/TrainingMaterialListItem";
import { EventBus } from '@/event-bus.js';
export default {
  name: "SupplementalDocumentation",
  components: {
    TrainingMaterialListItem
  },
  data: () => ({
    selected: false
  }),
  mounted() {
   this.setEventBus(); 
  },
  computed: {
    items: function() {
      return this.$store.getters.coursePlayer.assets.data;
    },
    course: function() {
      return this.$store.getters.coursePlayer;
    },
  },
  methods: {
    setEventBus() {
      EventBus.$on('WATCHED_ASSETS', () => {
         this.items = this.$store.getters.coursePlayer.assets.data;
      });
    },
  },
};
</script>